import { useMemo } from 'react';
import useSWR from 'swr';
import { WaitingListService } from '../../api/services/WaitingListService';
import type { WaitingListItemData } from '../../api/models/WaitingListItemData';
import { WaitingListStatus } from '../../api/models/WaitingListStatus';

const fetchCustomerWaitlistItems = async ([, email, accountId]: [string, string, string]) => {
  return WaitingListService.getCustomerWaitingListItems(email, accountId);
};

export const useCustomerWaitlistData = (email: string | null, accountId: string | null) => {
  const { data, isLoading, mutate } = useSWR<Array<WaitingListItemData>>(
    email && accountId ? ['customer-waitlist', email, accountId] : null,
    fetchCustomerWaitlistItems,
    {
      refreshInterval: 30000,
      revalidateOnFocus: true,
    },
  );

  const waitlistItems = useMemo(() => (data || []).filter((item) => item.status === WaitingListStatus.ACTIVE), [data]);

  return {
    waitlistItems,
    isLoading,
    mutate,
  };
};
